// extracted by mini-css-extract-plugin
export default {"heading":"styles__heading__db72784fafc4ab515a80","contents":"styles__contents__baa6d3b3444a7b054342"};